import React, { useEffect, useState } from 'react'
import { SparklesIcon } from '@heroicons/react/24/solid'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useLocation } from 'react-router-dom'
import { getFeature } from '../../api/askEvansApi'
import { AskEvansFloatingPanel } from './AskEvansFloatingPanel'

export const ASK_EVANS_FEATURE_EVENT = 'wps:ask-evans-feature'

export function GlobalAskEvansFab() {
  const location = useLocation()
  const [allowed, setAllowed] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    let cancelled = false
    const refresh = () => {
      getFeature()
        .then((feature) => {
          if (cancelled) return
          const next = feature.enabled && feature.allowed
          setAllowed(next)
          if (!next) setOpen(false)
        })
        .catch(() => {
          if (!cancelled) setAllowed(false)
        })
    }
    refresh()
    const onFeature = () => refresh()
    window.addEventListener(ASK_EVANS_FEATURE_EVENT, onFeature)
    return () => {
      cancelled = true
      window.removeEventListener(ASK_EVANS_FEATURE_EVENT, onFeature)
    }
  }, [location.pathname])

  if (!allowed || location.pathname === '/ask-evans') return null

  return (
    <>
      <AskEvansFloatingPanel open={open} onClose={() => setOpen(false)} />
      <button
        type="button"
        data-testid="ask-evans-fab"
        onClick={() => setOpen((value) => !value)}
        className={`fixed bottom-6 right-6 z-[70] inline-flex items-center justify-center bg-hero-red text-white shadow-[0_8px_24px_-6px_rgba(235,28,55,0.55)] transition-all hover:bg-hero-red-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-hero-red focus-visible:ring-offset-2 ${
          open ? 'h-14 w-14 rounded-full' : 'gap-2 rounded-full px-5 py-3 font-heading text-[15px] font-semibold'
        }`}
        aria-label={open ? 'Close Ask Evans' : 'Ask Evans'}
        aria-expanded={open}
      >
        {open ? (
          <XMarkIcon className="h-6 w-6" strokeWidth={2.25} aria-hidden />
        ) : (
          <>
            <SparklesIcon className="h-5 w-5 shrink-0 text-white" aria-hidden />
            Ask Evans
          </>
        )}
      </button>
    </>
  )
}
